import { userStore, types } from "@/BaseComponent";
import { apiService, header } from "@/services/interceptor";

export default {
    async noComment(param: types.ReqCommonPaging): Promise<types.ResPaging> {
        const res = {} as types.ResPaging;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/noComment", param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async report(type: 1 | 2): Promise<types.ResReportListForDashboard> {
        const res = {} as types.ResReportListForDashboard;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/report/" + type, null, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async visitHistory(param: types.ReqParamForDashboard): Promise<types.ResVisitHistoryForDashboard> {
        const res = {} as types.ResVisitHistoryForDashboard;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/visit/history", param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async visitHistoryRecent(type: 1 | 2 | 3): Promise<types.ResVisitHistoryForDashboard> {
        const res = {} as types.ResVisitHistoryForDashboard;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/visit/history/" + type, null, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },
};
